import type { RecentActionsLocale } from "@/locales/fr/recent-actions";

const recentActionsLocale: RecentActionsLocale = {
  recentActions: {
    recentActions: "Recent Actions",
    lastCall: "Last call",
    lastHardwareConfiguration: "Last Hardware Configuration",
    lastSoftwareUpdate: "Last Software Update",
  },
};

export default recentActionsLocale;
